import { CreateOrgChatMessageDto } from "../../model/chat/dto/CreateOrgChatMessageDto";
import { GetOrgChatMembersResponseDto } from "../../model/chat/dto/GetOrgChatMembersResponseDto";
import { GetOrgChatMessagesDto } from "../../model/chat/dto/GetOrgChatMessagesDto";
import { GetOrgChatMessagesResponseDto } from "../../model/chat/dto/GetOrgChatMessagesResponseDto";
import { GetOrgChatUnreadCountResponseDto } from "../../model/chat/dto/GetOrgChatUnreadCountResponseDto";
import { OrgChatMessage } from "../../model/chat/OrgChatMessage";
import { AtiraApi } from "../AxiosClient";

export class ChatAxios {
  static getOrgChatMessages(dto: GetOrgChatMessagesDto) {
    return AtiraApi.post<GetOrgChatMessagesResponseDto>(
      `/chat/org/messages/list`,
      dto,
    ).then(({ data }) => data);
  }

  static sendOrgChatMessage(dto: CreateOrgChatMessageDto) {
    return AtiraApi.post<OrgChatMessage>(`/chat/org/messages`, dto).then(
      ({ data }) => data,
    );
  }

  static getOrgChatMembers() {
    return AtiraApi.post<GetOrgChatMembersResponseDto>(
      `/chat/org/members`,
    ).then(({ data }) => data);
  }

  static getOrgChatUnreadCount() {
    return AtiraApi.post<GetOrgChatUnreadCountResponseDto>(
      `/chat/org/unread-count`,
    ).then(({ data }) => data);
  }

  static markOrgChatAsRead() {
    return AtiraApi.post<void>(`/chat/org/read`).then(({ data }) => data);
  }
}
